import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import DialogActions from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogActions';

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

/**
 * @deprecated use DialogActions instead
 */
const CenteredActions = ({
  className,
  classes,
  children,
}) => {
  const { actionsRef } = useModalContext();
  return (
    <Portal container={actionsRef.current}>
      <DialogActions>
        <Box
          className={classNames(classes.root, className)}
        >
          {children}
        </Box>
      </DialogActions>
    </Portal>
  );
};

CenteredActions.defaultProps = {
  className: '',
};

CenteredActions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default withStyles(styles)(CenteredActions);
